module.exports = __webpack_public_path__ + "media/call-soft.3a3cae12.wav";